module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-10.bb1ecfc8.png";